import * as React from 'react'
import styled from 'styled-components'
import { ConfiguratorText } from '../../atoms/configurator'
import { ConfiguratorBox } from '../../containers/configurator/ConfiguratorBox'
import { inject, observer } from 'mobx-react'

// const stefan = require('src/assets/redesign/Stefan_Atz.png')
const mail = require('src/assets/filter-mail.svg')
const phone = require('src/assets/phone-call-24-hours.svg')

@inject('confStore')
@observer

export default class ConfiguratorHelp extends React.Component<any> {
  constructor(props) {
    super(props)
  }
  getPhoto(){
    const { confStore } = this.props

    if(confStore.getOffer.customerAgent){
      const name = confStore.getOffer.customerAgent.name === 'Agentur Fröhlich' ?
        'Benu Bestattung':
        confStore.getOffer.customerAgent.name;
      return {
        name: name,
        photo: confStore.getOffer.customerAgent.photo,
        width: 144,
        height: 144,
        borderRadius: '50%', 
        alt: name
      }
    }else{
      return {
        name: 'Kontaktieren Sie uns kostenlos und jederzeit!',
        photo: 'https://res.cloudinary.com/dkyl4jbxx/image/upload/w_280,h_135,c_crop,c_fill,f_auto/v1614865189/cs_team_f504bb1539.png',
        width: 280,
        height: 135,
        borderRadius: '0px',
        alt:'Benu Team'
      }
    }
  }

  render() {
    let helpPhoto = this.getPhoto()
    return (
      <ConfiguratorBox>
        <h2>Brauchen Sie Hilfe bei der Planung?</h2>
        <ProfilePicture style={{borderRadius: helpPhoto.borderRadius}}
          height={helpPhoto.height}
          width={helpPhoto.width}
          src={helpPhoto.photo}
          alt={helpPhoto.alt}
        />
         <ConfiguratorText
          style={{
            textAlign: 'center',
            marginBottom: 10,
            width: '90%',
            margin: 'auto'
          }}>
          {helpPhoto.name}
        </ConfiguratorText>
        {/* <ConfiguratorText
          style={{
            textAlign: 'center',
            marginBottom: 25,
            width: '90%',
            margin: 'auto'
          }}>
          
        </ConfiguratorText> */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: 10,
            marginLeft: 0
          }}>
          <img src={mail} alt='Mail' style={{ height: 24, width: 24 }} />
          <p style={{ marginLeft: 20, marginBottom: 5 }}>
            <a style={{ color: '#5C5B5C' }} href='mailto:kontakt@benu.at'>
              kontakt@benu.at
            </a>
          </p>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: 10,
            marginLeft: 0
          }}>
          <img src={phone} alt='Telefon' style={{ height: 24, width: 24 }} />
          <p style={{ marginLeft: 20, marginBottom: 5 }}>
            <a style={{ color: '#5C5B5C' }} href='tel:0043800884404'>
              +43 800 88 44 04
            </a>
          </p>
        </div>
      </ConfiguratorBox>
    )
  }
}

const ProfilePicture = styled.img`
  display: block;
  margin: 35px auto;
`



// WEBPACK FOOTER //
// ./src/components/organisms/configurator/ConfiguratorHelp.tsx